export const fetchWithCredentials = async (url: string, options = {}) => {
  return await fetch(url, {
    ...options,
    credentials: 'include', // Always send credentials
  });
};
